import React from "react";
import { useTranslation } from "react-i18next";

const baseColor = "#06a7c8";
const accentColor = "#26b36b";
const lightBorder = "#d6d6d6";

const ClinicPrintFrame = ({
  doctorName,
  doctorTitle,
  date,
  patientName,
  patientAge,
  patientGender,
  leftNotes,
  rxTitle = "Rx",
  children,
  footerText,
  compact = false,
}) => {
  const { t } = useTranslation();

  return (
    <div
      style={{
        width: "210mm",
        minHeight: "297mm",
        margin: "0 auto",
        backgroundColor: "#fff",
        border: `1px solid ${lightBorder}`,
        boxSizing: "border-box",
        padding: compact ? "8mm 9mm" : "9mm 10mm",
        fontFamily: "Arial, sans-serif",
        color: "#111",
        position: "relative",
      }}
    >
      <div style={{ marginBottom: "6mm" }}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div
            style={{
              width: "45%",
              height: "4mm",
              background: baseColor,
              clipPath: "polygon(0 0, 92% 0, 82% 100%, 0 100%)",
            }}
          />
          <div
            style={{
              width: "45%",
              height: "4mm",
              background: baseColor,
              clipPath: "polygon(8% 0, 100% 0, 100% 100%, 18% 100%)",
            }}
          />
        </div>
      </div>

      <header
        style={{
          display: "grid",
          gridTemplateColumns: "1fr auto 1fr",
          gap: "8px",
          alignItems: "center",
          marginBottom: "4mm",
        }}
      >
        <div>
          <div style={{ fontSize: "7mm", color: baseColor, fontWeight: 700 }}>
            {t("print.turkishClinic")}
          </div>
          <div style={{ fontSize: "3.5mm", lineHeight: 1.2 }}>{doctorName}</div>
          {doctorTitle ? (
            <div style={{ fontSize: "3.2mm", lineHeight: 1.2 }}>{doctorTitle}</div>
          ) : null}
        </div>

        <img
           src="/etimad-logo.jpeg"
              alt="Company Logo"
          style={{ width: "24mm", height: "24mm", objectFit: "contain" }}
        />

        <div style={{ textAlign: "right", direction: "rtl" }}>
          <div style={{ fontSize: "7mm", color: baseColor, fontWeight: 700 }}>
            Ettemaad Hospital
          </div>
          <div style={{ fontSize: "3.2mm", lineHeight: 1.2 }}>
            {t("print.tagline")}
          </div>
        </div>
      </header>

      <div
        style={{
          height: "1.6mm",
          width: "66%",
          margin: "0 auto 4mm",
          background: accentColor,
          borderRadius: "999px",
        }}
      />

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.3fr 1.1fr 0.7fr 0.7fr 0.9fr",
          alignItems: "center",
          gap: "4px",
          fontSize: "3.2mm",
          color: "#0b8eb0",
          paddingBottom: "3mm",
          marginBottom: "2mm",
          borderBottom: `1px solid ${lightBorder}`,
        }}
      >
        <div>Name: {patientName || ".........."}</div>
        <div>Age: {patientAge || "......"}</div>
        <div>Gender: {patientGender || "......"}</div>
        <div />
        <div style={{ textAlign: "right" }}>Date: {date || ".........."}</div>
      </div>

      <div style={{ display: "flex", minHeight: compact ? "180mm" : "200mm" }}>
        <div
          style={{
            width: "25%",
            paddingRight: "3mm",
            borderRight: `1px solid ${baseColor}`,
          }}
        >
          <div
            style={{
              fontSize: "6mm",
              color: "#1f1f1f",
              fontStyle: "italic",
              fontWeight: 700,
              marginBottom: "6mm",
            }}
          >
            Clinical Notes
          </div>

          {(leftNotes || ["B.P", "P.R", "R.R", "T.C"]).map((label) => (
            <div
              key={label}
              style={{
                fontWeight: 700,
                color: baseColor,
                marginBottom: "8mm",
                fontSize: "4mm",
              }}
            >
              {label}
            </div>
          ))}
        </div>

        <div style={{ flex: 1, paddingLeft: "4mm" }}>
          <div
            style={{
              fontSize: "11mm",
              lineHeight: 1,
              color: accentColor,
              fontFamily: "cursive",
              marginBottom: "3mm",
            }}
          >
            {rxTitle}
          </div>
          <div>{children}</div>
        </div>
      </div>

      <footer style={{ marginTop: "8mm" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-end",
            marginBottom: "2mm",
          }}
        >
          <img
            src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`}
            alt="footer logo"
            style={{ width: "20mm", opacity: 0.25 }}
          />
          <div
            style={{
              width: "72%",
              height: "7mm",
              background: baseColor,
              clipPath: "polygon(0 100%, 9% 0, 91% 0, 100% 100%)",
            }}
          />
        </div>
        <div style={{ textAlign: "center", fontSize: "3.3mm", fontWeight: 700 }}>
          {footerText || t("print.tagline")}
        </div>
      </footer>
    </div>
  );
};

export default ClinicPrintFrame;
